import axios from 'axios';
import swal from 'sweetalert';

export default class Account {
    constructor() {

    }

    init() {
        
    }

    orders() {
        window.App.common.live('button.accountOrderDetail','click', (event,target) => {
            [...document.querySelectorAll('ul.accountOrders li.singleOrder')].forEach((el)=>{
                el.classList.remove('open');
            });
            const id = target.getAttribute('data-uid');
            if(document.getElementById(id)){
                document.getElementById(id).classList.add("open");
            }
        });

        window.App.common.live('button.reorder','click', (event,target) => {
            const uid = target.getAttribute('data-uid');
            if(uid){
                axios.post("./account/reorder",{uid}).then(function (response) {
                    if(response.data.js && typeof response.data.js == 'object'){
                        response.data.js.forEach((script)=>{
                            (new Function(script)).call(response.data);
                        });
                    }
                })
            }
        });
    }

    addresses() {

        window.App.common.live('button.accountDeleteAddress','click', (event, target) => {
            const uid = target.getAttribute('data-uid');
            if(uid){
                swal({
                    title: "Emin misiniz?",
                    text: "Seçili adresi silmek istediğinize emin misiniz?",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true
                }).then((willDelete) => {
                    if (willDelete) {
                        axios.post("./account/deleteaddress",{uid}).then(function (response) {
                            if(response.data.js && typeof response.data.js == 'object'){
                                response.data.js.forEach((script)=>{
                                    (new Function(script)).call(response.data);
                                });
                            }
                        });
                    }
                });
            }
        });

    }

    finalize() {
        //console.log("contact finalized");
    }
}